import React from 'react';
import ValidationSection from './validation_section';
import ValidationError from './validation_error';
import Arrow from '~/images/drop-down-arrow.svg';

export default (props) => {
  return (
    <ValidationSection className="dropdown-container validation-error--v2" errors={props.errors}>
      <div className="drop-down">
        <div className="drop-down__inner">
          <select className="drop-down__select" onChange={props.onChange} value={props.value} name={props.name}>
            {props.placeholder && (
              <option className="drop-down__option--placeholder" value="">
                {props.placeholder}
              </option>
            )}
            {props.items.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <img className="drop-down__arrow" src={Arrow} />
        </div>
      </div>
      <ValidationError errors={props.errors} />
    </ValidationSection>
  );
};
